<template>
  <vx-card no-shadow>
    <div id="editClubBookingSettingLoadingDiv" class="vs-con-loading__container ">

      <div class="vx-row mt-2">
        <div class="vx-col sm:w-full w-full mb-5">
          <vs-input v-validate="'numeric|between:1,30'" name="cancellation_time_period" ref="cancellation_time_period" class="w-full" label-placeholder="Booking cancel period in days" v-model="clubData.cancellation_time_period"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('cancellation_time_period')">{{ errors.first('cancellation_time_period') }}</span>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <!-- <vs-button @click="resetClubData" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
        <vs-button @click="validateClubData" class="ml-4 mt-2">Save Changes</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueDawa from '@ancaio/vue-dawa/sfc'
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
  components: {
    VueDawa,
  },
  data() {
    return {
      oneLineAddress : "",
      // clubData : JSON.parse(localStorage.getItem("clubData")),
      clubData : {
        cancellation_time_period : "",
      },
      // clubOriginalData : JSON.parse(localStorage.getItem("clubData")),
      clubOriginalData : {
        cancellation_time_period : "",
      },
    }
  },
  computed: {
    // clubData() {
    //   return this.$store.state.clubManagement.club
    // },
    // getBookingCancelData:{
    //   get(){
    //     var days = 1;
    //     var hours = this.clubData.cancellation_time_period.substring(0, 2)
    //     return hours / 24;
    //   },
    //   set(newName){
    //     if(Number.isInteger(parseInt(newName))){
    //       this.clubData.cancellation_time_period = newName*24+":00:00"
    //     }
        
    //   } 
    // },
  },
  methods: {
    selectAddressItem (payload, objectName) {
      this.oneLineAddress = payload.oneLineAddress
    },
    resetClubData() {
      this.clubData = this.clubOriginalData
    },
    validateClubData() {
      this.$validator.validateAll().then(result => {
        if (result) this.updateClubData()
      })
    },
    updateClubData() {
      var self = this
      
      this.$vs.loading({
        container: '#editClubBookingSettingLoadingDiv',
        scale: 0.6
      })

      let clubData = {
        cancellation_time_period : this.clubData.cancellation_time_period,
      }

      this.$store.dispatch("userManagement/updateClubSetting", clubData)
        .then(res => { 
            this.$vs.loading.close('#editClubBookingSettingLoadingDiv > .con-vs-loading')

            this.$vs.notify({
                title: "Success.",
                text: "Settings updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        })
        .catch(err => { 
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }

          this.$vs.loading.close('#editClubBookingSettingLoadingDiv > .con-vs-loading')
        })

    },
    getClubData() {
      this.$store.dispatch("clubManagement/getClubData")
        .then(res => { 
          this.clubData = res.data
          this.clubOriginalData = res.data

          if(this.clubData.cancellation_time_period){
            var hours = this.clubData.cancellation_time_period.substring(0, this.clubData.cancellation_time_period.length - 6)
            this.clubData.cancellation_time_period = hours / 24;
            this.clubOriginalData.cancellation_time_period = hours / 24;
          }
        })
        .catch(err => { })
    },
  },
  created() {
    if(!moduleClubManagement.isRegistered) {
        this.$store.registerModule('clubManagement', moduleClubManagement)
        moduleClubManagement.isRegistered = true
    }

    this.getClubData()
  },
}
</script>
